import { render, staticRenderFns } from "./AddDeliverData.vue?vue&type=template&id=df2bef26&scoped=true&"
import script from "./AddDeliverData.vue?vue&type=script&lang=js&"
export * from "./AddDeliverData.vue?vue&type=script&lang=js&"
import style0 from "./AddDeliverData.vue?vue&type=style&index=0&id=df2bef26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2bef26",
  null
  
)

export default component.exports